"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ShouldAutoFocus = (refElement) => {
    if (!refElement)
        return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll('*[data-autofocus],*[autofocus]').length);
    return !autoFocusSet;
};
exports.default = ShouldAutoFocus;
